export const ESTIMATED_PRODUCT_PROFIT = `
query estimatedProductProfit (
    $tenant_id: Int!
    $input: EstimatedProductProfitInput!
  ) {
  estimatedProductProfit (
    tenant_id: $tenant_id
    input: $input
  ) {
    __typename
    ...on EstimatedProductProfit {
      external_order_profit
      own_order_profit
    }
    __typename
    ...on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
